import React from 'react'
import { useTranslation } from 'react-i18next'
import FilterLink from './FilterLink'
import FilterSideModal from './FilterSideModal'
import { useChangeFilterValue, useFilterValue } from '@btime/react-contexts'
import FilterListItem from '../list/FilterListItem'

const ActivatedFilter = ({ presentation = 'bar' }) => {
  const { t } = useTranslation('components')
  const [open, setOpen] = React.useState(false)

  const handleChange = useChangeFilterValue()
  const filter = useFilterValue('enabled')

  const handleSetFilter = value => {
    const filterValue = filter === value ? undefined : value
    handleChange('enabled', filterValue)
  }

  const DynamicComponent = presentation === 'bar' ? FilterLink : FilterListItem

  return (
    <>
      <DynamicComponent
        icon="RiToggleLine"
        label={
          filter === undefined
            ? t('filter.enabledDisabled')
            : filter === 'true'
            ? t('filter.enabled')
            : t('filter.disabled')
        }
        value={filter === undefined ? false : filter === 'true' ? t('filter.enabled') : t('filter.disabled')}
        onClick={() => setOpen(true)}
      />

      <FilterSideModal
        open={open}
        onClose={() => setOpen(false)}
        label={t('filter.enabledDisabled')}
        renderOptions={() => (
          <>
            <FilterListItem
              onClick={() => handleSetFilter('true')}
              label={t('filter.enabled')}
              icon="RiToggleFill"
              isSelected={filter === 'true'}
            />
            <FilterListItem
              onClick={() => handleSetFilter('false')}
              label={t('filter.disabled')}
              icon="RiToggleLine"
              isSelected={filter === 'false'}
            />
          </>
        )}
      />
    </>
  )
}

export default ActivatedFilter
